//
//
//
//
//
//
//

// import gStartUp from '@/common/components/g-start-up/'
import firebase from '@/common/mixin/firebase/'
export default {
  name: 'App',
  mixins: [firebase],
  // components: { gStartUp },
  provide() {
    return {
      parentRoot: this
    }
  },
  computed: {
    viewHeight() { // 可是区域的高度
      return (document.documentElement.clientHeight || document.body.clientHeight) + 'px'
    }
  },
  data() {
    return {
      isRouterAlive: true ,// 路由刷新
      // startImg: require('./assets/image/common/start-up.jpg')
      FirebaseTypeKey: '11ic-FirebaseType',
      firebaseConfig: {
        apiKey: "AIzaSyBADpHQvMpMZev8DfgdI5cV1JYsRwm0-jI",
        authDomain: "ic-8cb9c.firebaseapp.com",
        projectId: "ic-8cb9c",
        storageBucket: "ic-8cb9c.appspot.com",
        messagingSenderId: "774634189724",
        appId: "1:774634189724:web:67179757c346a52bda0e59",
        measurementId: "G-HBJCBLW7M1"
      }
    }
  },
  methods: {
    reload() { // 刷新页面, 比如页面切换多语言数据重置
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
  created() {
    
    this.FirebaseInte()
    this.getFirebaseRedirectResult()
    
  },
}



// WEBPACK FOOTER //
// ./src/pages/build902/App.vue